<template>
    <div class="row" v-if="!show">
        <div class="col-md-9">
            <Loading v-if="showLoading" />
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات سفارش</div>
                <div class="card-body">
                    <div class="timeline-steps aos-init aos-animate mb-2" v-if="false">
                        <div v-for="(step,index) in flows" :key="index" :class="order.sort == step.sort ? 'timeline-step mb-0 current' : (order.sort > step.sort ? 'timeline-step active' : 'timeline-step mb-0')">
                            <div class="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top">
                                <div class="inner-circle"></div>
                                <p class="h6 text-muted mt-2 mb-0 mb-lg-0">{{ step.sort > order.sort ? step.title : (step.subFlows[order.flowStepStatusId] || step.title) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details" v-if="order.domainMetadata && Object.keys(order.domainMetadata).length">
                            <tbody>
                                <tr>
                                    <td>شماره سفارش:</td>
                                    <td>{{ order.orderId }}</td>
                                    <td>وضعیت سفارش:</td>
                                    <td>{{ order.statusTitle }}</td>
                                    <td>نوع سفارش:</td>
                                    <td>{{ order.orderType || '-' }}</td>
                                </tr>
                                <tr>
                                    <td>وضعیت سفارش:</td>
                                    <td>{{ order.statusTitle }}</td>
                                    <td>تاریخ سفارش:</td>
                                    <td>{{ order.createdAtPersian }}</td>
                                    <td>نام مشتری:</td>
                                    <td>{{ order.domainMetadata.firstName ? (order.domainMetadata.firstName + ' ' + order.domainMetadata.lastName) : order.domainMetadata.companyNameFa }}</td>
                                </tr>
                                <tr>
                                    <td>شماره همراه:</td>
                                    <td>{{ order.domainMetadata.mobile || '-' }}</td>
                                    <td>شناسه ملی:</td>
                                    <td>{{ order.domainMetadata.nationalId }}</td>
                                    <td>نحوه ارسال:</td>
                                    <td>{{ order.shipping || '-' }}</td>
                                </tr>
                                <tr v-if="order.address">
                                    <td>آدرس:</td>
                                    <td>{{ order.address.addressString }}</td>
                                    <td>کد پستی:</td>
                                    <td>{{ order.address.postalCode }}</td>
                                    <td>شماره تماس:</td>
                                    <td>{{ order.address.phone }}</td>
                                </tr>
                                <tr v-if="order.description" style="border-left: 1px solid #262644">
                                    <td>توضیحات عدم تایید:</td>
                                    <td colspan="5">{{ order.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">کارت های این سفارش</div>
                        <div class="card-body">
                            <div class="card bg-gray-100 mb-3" v-for="(orderItem,index) in order.orderItems" :key="index">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <img :src="orderItem.theme ? 'https://cardapi.sabinarya.com' + orderItem.theme.address : orderItem.imageUrl" :alt="orderItem.theme ? orderItem.theme.title : ''" class="my-3 rounded-10">
                                        </div>
                                        <div class="col-md-9 pr-0 mt-3">
                                            <h5 class="theme-title mb-3"><b>{{ orderItem.theme ? orderItem.theme.title : orderItem.title }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count && !orderItem.approvedCount">تعداد : <b>{{ orderItem.count }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count && orderItem.approvedCount"> <b>{{ orderItem.approvedCount }}</b> کارت از <b>{{ orderItem.count }}</b> کارت تایید شده</h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count">مبلغ شارژ هر کارت : <b>{{ (orderItem.depositId && orderItem.depositId != 41) ? (new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(orderItem.chargePrice) + ' ریال') : 'بدون شارژ' }}</b></h5>
                                            <h5 class="theme-title mb-3">وضعیت : 
                                                <span v-if="orderItem.status == 1"><b>در انتظار بررسی</b></span>
                                                <span v-else-if="orderItem.status == 2"><b>تایید شده</b></span>
                                                <span v-else-if="orderItem.status == 3"><b>عدم تایید</b></span>
                                                <span v-else-if="orderItem.status == 4"><b>پرداخت نشده</b></span>
                                                <span v-else><b>شارژ شده</b></span>
                                            </h5>
                                            <h5 class="theme-title">نوع کارت : 
                                                <span v-if="orderItem.cardTypeId == 1"><b>کارت هدیه فیزیکی آماده</b></span>
                                                <span v-else-if="orderItem.cardTypeId == 2"><b>کارت هدیه مجازی آماده</b></span>
                                                <span v-else-if="orderItem.cardTypeId == 3"><b>کارت هدیه فیزیکی دلخواه</b></span>
                                                <span v-else><b>کارت هدیه مجازی دلخواه</b></span>
                                            </h5>
                                            <div class="header-button-box">
                                                <button class="btn btn-primary btn-rounded" v-if="orderItem.cardTypeId != 1 && orderItem.cardTypeId != 2" @click="downloadImage(orderItem.imageUrl)" target="_blank">مشاهده تصویر کارت</button>
                                                <button class="btn btn-warning mr-2 btn-rounded" v-if="false" target="_blank">دانلود تصویر کارت</button>
                                                <button class="btn btn-info mr-2 btn-rounded" v-if="orderItem.voice" data-target="#voice-modal" data-toggle="modal" @click="openVoice(orderItem.voice)">صدای ضبط شده</button>
                                                <button class="btn btn-dark mr-2 btn-rounded" v-if="orderItem.text" @click="setCurrentText(orderItem.text)" data-target="#card-text" data-toggle="modal">متن کارت</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="card-text" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">متن کارت</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <p class="w-100 text-center">{{ currentText }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="voice-modal" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">صدای ضبط شده</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <audio :src="currentVoice" controls class="w-100 mb-0"></audio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="transactions.length">
                        <Loading v-if="showLoading" />
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">لیست پرداخت ها</div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>مبلغ</th>
                                        <th>شماره مرجع</th>
                                        <th>شماره پیگیری</th>
                                        <th>وضعیت</th>
                                        <th>تاریخ</th>
                                        <th>تصویر رسید</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(transaction,index) in transactions" :key="index">
                                        <th>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount) + ' ریال' }}</th>
                                        <th>{{ transaction.trRrn || '-' }}</th>
                                        <th>{{ transaction.trPaymentid || '-' }}</th>
                                        <th v-if="transaction.transactionStatusId == 2"><span class="badge badge-success">موفق</span></th>
                                        <th v-else-if="transaction.transactionStatusId == 41"><span class="badge badge-dark">در انتظار تایید</span></th>
                                        <th v-else><span class="badge badge-danger">ناموفق</span></th>
                                        <th>{{ new Date(transaction.createdAt).toLocaleTimeString('fa-ir') + ' - ' + new Date(transaction.createdAt).toLocaleDateString('fa-ir') }}</th>
                                        <th v-if="transaction.receiptId"><a @click="openReceipts(transaction.transactionId)" target="_blank" style="cursor: pointer">کلیک کنید</a></th>
                                        <th v-else>-</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mb-3" v-if="(order.orderTypeId == 1 || order.orderTypeId == 61) && (order.flowStepStatusId == 1 || order.flowStepStatusId == 21) && !order.financeVerify">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">ثبت اطلاعات پرداخت</div>
                <form class="card-body" v-on:submit.prevent="submitPayment">
                    <div class="form-group">
                        <label>شناسه پرداخت / شماره پیگیری</label>
                        <input type="tel" v-mask="'##############################'" class="form-control ltr-input" v-model="paymentIdentifier" maxlength="30">
                    </div>
                    <div class="form-group">
                        <label>شماره ارجاع / شماره درخواست</label>
                        <input type="tel" v-mask="'############'" class="form-control ltr-input" v-model="rrn" maxlength="12">
                    </div>
                    <div class="form-group">
                        <label>مبلغ (ریال)</label>
                        <input type="tel" class="form-control ltr-input" v-model="amount" @keyup="numberFormat">
                    </div>
                    <div class="form-group">
                        <label>تصویر فیش واریزی</label>
                        <div class="input-group file-browser">
                            <input id="file-input" type="text" class="form-control border-left-0 browse-file" placeholder="انتخاب کنید" readonly="">
                            <label class="input-group-btn">
                                <span class="btn btn-primary">
                                    انتخاب <input type="file" style="display: none;" accept="image/jpeg" @change="setFile">
                                </span>
                            </label>
                        </div>
                    </div>
                    <button class="btn btn-success btn-block">ثبت اطلاعات</button>
                </form>
            </div>
            <div class="card mb-3" v-if="order.flowStepStatusId == 7">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">فایل پن کارت ها</div>
                <div class="card-body">
                    <button class="btn btn-primary btn-block" @click="getSheetFile">دانلود فایل</button>
                </div>
            </div>
            <div class="card mb-3">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات مالی</div>
                <div class="card-body">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ سفارش:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(Math.abs(order.amount - (order.shippingCost || 0))) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between" v-if="order.discount != 0">
                        <div class="m-1">
                            <span>مبلغ تخفیف:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.discount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>هزینه ارسال:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.shippingCost || 0) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ کل:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.totalAmount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>تعداد محصول:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ count }}</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>وضعیت پرداخت:</span>
                        </div>
                        <div class="m-1">
                            <span v-if="order.financeVerify" class="badge badge-success">پرداخت شده</span>
                            <span v-else class="badge badge-danger">پرداخت نشده</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Single',
    data(){
        return {
            showLoading: true,
            show: true,
            rejectionList: [],
            currentText: '',
            currentVoice: '',
            paymentIdentifier: '',
            rrn: '',
            amount: 0,
            file: '',
            currentOrderItemId: 0,
            transactions: [],
            rejections: [],
            rejectionId: 0,
            orderRejectionId: 0,
            count: 0,
            pan: '',
            searchedPan: false,
            downloadedFile: false,
            pansFile: '',
            cardData: {},
            returns: [],
            returnId: 0,
            itemIds: [],
            returnDescription: '',
            order: {},
            cardPanData: {},
            organizationRejectDescription: '',
            organizationDiscount: 0,
            organizationApproveStatus: true,
            showOrganizationDescriptionBox: false,
            flows: [],
            csvFileResult: ''
        }
    },
    methods: {
        async getData(){
            this.showLoading = true;
            this.$api.get('Orders/' + this.$route.params.id).then(({data}) => {
                this.show = false;
                let orderItems = [];
                if(data.status){
                    this.showLoading = false;
                    if(data.result.orderTypeId != 1)
                        this.count = data.result.orderItems.length;
                    let count = 0;
                    data.result.orderItems.map(item => {
                        count += item.approvedCount ? item.approvedCount : item.count;
                        item.acceptCount = 0;
                        item.rejectCount = 0;
                        this.itemIds.push(item.orderItemId);
                        if(item.cardTypeId == 1 || item.cardTypeId == 2){
                            if(item.cardTypeId == 2){
                                let orderItemVoice = item.cardMetadata.filter(item => item.metadataKeyId == 1)[0];
                                let orderItemText = item.cardMetadata.filter(item => item.metadataKeyId == 3)[0];
                                item.voice = orderItemVoice ? ('data:audio/ogg;base64,' + orderItemVoice.value) : '';
                                item.text = orderItemText ? orderItemText.value : '';
                            }
                            item.theme.title = item.cardTypeId == 2 ? (item.theme.title + ' مجازی') : item.theme.title;
                            orderItems.push(item);
                        }else{
                            let orderItemImage = item.cardMetadata.filter(item => item.metadataKeyId == 2)[0];
                            let orderItemVoice = item.cardMetadata.filter(item => item.metadataKeyId == 1)[0];
                            let orderItemText = item.cardMetadata.filter(item => item.metadataKeyId == 3)[0];
                            let orderItem = {
                                imageUrl: 'data:image/png;base64,' + orderItemImage.value,
                                voice: orderItemVoice ? ('data:audio/ogg;base64,' + orderItemVoice.value) : '',
                                text: orderItemText ? orderItemText.value : '',
                                title: item.cardTypeId == 3 ? 'کارت هدیه فیزیکی دلخواه' : 'کارت هدیه مجازی دلخواه',
                                cardTypeId: item.cardTypeId,
                                count: item.count,
                                status: item.status,
                                orderItemId: item.orderItemId,
                                depositId: item.depositId,
                                chargePrice: item.chargePrice,
                                cardId: item.cardId
                            };
                            orderItems.push(orderItem);
                        }
                    });
                    this.count = count;
                    let orderDetails = {
                        ...data.result,
                        orderItems
                    };
                    this.order = orderDetails;
                }
            }).catch(({response}) => {
                this.showLoading = false;
            });
            await this.$api.get('Flows/' + 2).then(({data}) => {
                let flows = data.result;
                let finalFlows = [];
                let subFlows = {};
                flows.map(flow => {
                    subFlows = {};
                    flow.flowStepStatuses.map(flowStep => {
                        subFlows[flowStep.flowStepStatusId] = flowStep.title
                    });
                    finalFlows.push({
                        title: flow.title,
                        sort: flow.sort,
                        subFlows
                    });
                });
                this.flows = finalFlows;
            });
            this.$api.get('Management/Rejections').then(({data}) => {
                this.rejections = data.result;
            });
            this.$api.post('Management/Transactions',{orderId: parseInt(this.$route.params.id)}).then(({data}) => {
                if(data.transactions && data.transactions.length)
                    this.transactions = data.transactions;
            });
            this.$api.get('Management/Returns').then(({data}) => {
                this.returns = data.result;
            });
        },
        getSheetFile(){
            this.showLoading = true;
            this.$api.get('Organizations/Orders/Sheet/' + this.$route.params.id).then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.fileString);
                let fileName = data.result.fileString;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            }).finally(() => {
                this.showLoading = false;
            });
        },
        numberFormat(){
            let value = this.amount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(this.amount.toString().replace(/,/g,'') > this.order.totalAmount)
                this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.totalAmount);
            else
                this.amount = value;
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        submitPayment(){
            this.showLoading = true;
            const postedData = {
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                amount: parseInt(this.amount.toString().replace(/,/g,'')),
                orderId: parseInt(this.$route.params.id),
                base64Receipt: this.file
            };
            this.$api.post('Organizations/SubmitPayment',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.paymentIdentifier = this.amount = this.rrn = this.pansFile = '';
                    document.getElementById('file-input').setAttribute('placeholder','');
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت اطلاعات پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        openReceipts(id){
            window.open('https://cardapi.sabinarya.com/api/v1/Management/Receipts/' + id);
        },
        downloadImage(base64){
            let image = new Image();
            image.src = base64;
            let newWindow = window.open('');
            newWindow.document.write(image.outerHTML);
        },
        downloadImageDirectly(itemId){
            window.open('https://cardapi.sabinarya.com/api/v2/Metadata/Download?orderItemId=' + itemId);
        },
        openVoice(voice){
            this.currentVoice = voice;
        },
        decodeBase64(s){
            var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
            var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for(i=0;i<64;i++){e[A.charAt(i)]=i;}
            for(x=0;x<L;x++){
                c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
                while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
            }
            return r;
        },
        setCurrentText(text){
            this.currentText = decodeURIComponent(escape(atob(text)));
        }
    },
    created(){
        this.getData();
    }
}
</script>